/**
 * Regras do perfil MASTER (perfil de acesso total do sistema).
 *
 * Somente um usuário MASTER pode cadastrar ou editar outro usuário com o
 * perfil MASTER — a mesma regra é reforçada na API (SaveUsuarioCommandHandler).
 */

export const PERFIL_MASTER = "MASTER";

/** Verifica se o perfil informado é o MASTER (comparação sem case). */
export const isPerfilMaster = (perfil?: { nome?: string } | string | null) => {
  const nome = typeof perfil === "string" ? perfil : perfil?.nome;
  return nome?.trim().toUpperCase() === PERFIL_MASTER;
};
